export default "__VITE_ASSET__LU5RIMzC__"